import {
  Group,
  Container,
  Grid,
  TextInput,
  Button,
  Alert,
  Select,
  Stack,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useLocation } from "wouter";
import { createUser, sendUserInvitation } from "../api";
import { notifications } from "@mantine/notifications";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export default function UserAdd({ realm }) {
  const [isLoading, setIsLoading] = useState(false);
  const [, setLocation] = useLocation();
  const { t } = useTranslation("Users");

  const addUserHandler = (data) => {
    setIsLoading(true);
    createUser(data)
      .then((response) => {
        // setLocation(`/users/${response.id}`); tbd redirect to details and show pending invites there
        sendUserInvitation(response.userId)
          .then(() => {
            setLocation("/users");
            notifications.show({
              color: "green",
              autoClose: 3000,
              title: t("invitation_sent"),
            });
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      role: "TenantUser",
      realm: realm,
      email: "",
      firstName: "",
      lastName: "",
    },
    validate: {
      email: (val) =>
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val)
          ? null
          : "Invalid email",
    },
  });

  return (
    <Container size="xs" px={0}>
      <Alert mb="md">
        {t("invite_user_info")}
        {/* TBD: Limit domain to same
        domain as tenant (tenant config, multiple domains) TBD: Limit seats */}
      </Alert>
      <Grid justify="space-between" gap="2px">
        <Grid.Col span={12}>
          <form onSubmit={form.onSubmit(addUserHandler)}>
            <Stack gap="sm">
              <TextInput
                {...form.getInputProps("firstName")}
                key={form.key("firstName")}
                label={t("first_name")}
              />
              <TextInput
                {...form.getInputProps("lastName")}
                key={form.key("lastName")}
                label={t("last_name")}
              />
              <TextInput
                {...form.getInputProps("email")}
                key={form.key("email")}
                label={t("email")}
                withAsterisk
              />
              <Select
                label={t("role")}
                data={["TenantUser", "TenantAdmin", "TenantOwner"]}
                {...form.getInputProps("role")}
                key={form.key("role")}
              />

              <Group justify="flex-end">
                <Button loading={isLoading} type="submit" mt="md">
                  {t("invite_user")}
                </Button>
              </Group>
            </Stack>
          </form>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
